import type { ConstValues } from '@openx/types/helpers.ts';

export const DealRowActionType = {
  DETAILS: 'DETAILS',
  CLONE: 'CLONE',
  EDIT: 'EDIT',
  TROUBLESHOOT: 'TROUBLESHOOT',
  DELETE: 'DELETE',
  PAUSE: 'PAUSE',
  RESUME: 'RESUME',
  USE_SHARED_TARGETING: 'USE_SHARED_TARGETING',
  DOWNLOAD: 'DOWNLOAD',
} as const;
export type DealRowActionType = ConstValues<typeof DealRowActionType>;

export const MAX_DEAL_GROUP_SIZE = 10;
